import { DateTime } from 'luxon';

export enum MetadataEntityFilterType {
    Flag = 'Flag',
    AutoComplete = 'AutoComplete',
    List = 'List',
    Calendar = 'Calendar',
    RelativeDate = 'RelativeDate',
    TimeRange = 'TimeRange',
    Time = 'Time',
    Number = 'Number',
}

type MetadataEntityFieldFilterBaseOptions = {
    preventClear?: boolean;
    readonly?: boolean;
}

export type MetadataEntityFieldTypeCalendar = {
    type: MetadataEntityFilterType.Calendar | MetadataEntityFilterType.Time,
    options?: MetadataEntityFieldFilterBaseOptions & {
        showTime?: boolean;
        timezone?: string;

        /** Min Date, you probably want to set this in code at run time */
        minDate?: Date | DateTime | (() => Date | DateTime);

        /** Max Date, you probably want to set this in code at run time */
        maxDate?: Date | DateTime | (() => Date | DateTime);
    }
}

export type MetadataEntityFieldTypeRelativeDate = {
    type: MetadataEntityFilterType.RelativeDate,
    options?: MetadataEntityFieldFilterBaseOptions & {
        timezone?: string;

        /** 'date' shows day-based operators, 'time' shows hour/minute-based operators */
        mode?: 'date' | 'time';

        /** 'past' shows only past operators, 'future' shows only future, 'all' shows both */
        direction?: 'past' | 'future' | 'all';
    }
}

export type MetadataEntityFieldTypeTimeRange = {
    type: MetadataEntityFilterType.TimeRange,
    options?: MetadataEntityFieldFilterBaseOptions & {
        timezone?: string;

        /** 'past' shows only past operators, 'future' shows only future, 'all' shows both */
        direction?: 'past' | 'future' | 'all';
    }
}

/** @deprecated Use MetadataEntityFieldTypeCalendar, MetadataEntityFieldTypeRelativeDate, or MetadataEntityFieldTypeTimeRange */
export type MetadataEntityFieldTypeDate = MetadataEntityFieldTypeCalendar | MetadataEntityFieldTypeRelativeDate | MetadataEntityFieldTypeTimeRange;

export type MetadataEntityFieldTypeString = {
    type: MetadataEntityFilterType.AutoComplete,
    options?: MetadataEntityFieldFilterBaseOptions & {
        singleSelect?: boolean,
    }
}

export type MetadataEntityFieldTypeNumber = {
    type: MetadataEntityFilterType.Number,
    options?: MetadataEntityFieldFilterBaseOptions
}

export type MetadataEntityFieldTypeFlag = {
    type: MetadataEntityFilterType.Flag,
    options?: MetadataEntityFieldFilterBaseOptions
}

export type MetadataEntityFieldTypeList = {
    type: MetadataEntityFilterType.List,
    options?: MetadataEntityFieldFilterBaseOptions & {
        singleSelect?: boolean,
    }
}

export type MetadataEntityFieldFilterOptions =
    MetadataEntityFieldTypeFlag |
    MetadataEntityFieldTypeDate |
    MetadataEntityFieldTypeString |
    MetadataEntityFieldTypeNumber |
    MetadataEntityFieldTypeList |
    MetadataEntityFieldTypeRelativeDate;